<template>
  <main class="win">
    <img class="spot-right" src="../assets/images/spot-right-min.png">
    <div class="gain">
        <img v-if="lot == 'lot1'" class="lot1" src="../assets/images/gain1-min.png">
        <img v-if="lot == 'lot2'" class="lot2" src="../assets/images/gain2-min.png">
        <img v-if="lot == 'lot3'" class="lot3" src="../assets/images/gain3-min.png">
        <img v-if="lot == 'lot4'" class="lot4" src="../assets/images/gain4-min.png">
        <img v-if="lot == 'lot5'" class="lot5" src="../assets/images/gain5-min.png">
        <img v-if="lot == 'lot6'" class="lot6" src="../assets/images/gain6-min.png">

        <p v-if="lot == 'lot1'">Vous avez gagné un an de course à hauteur de 1800 €  <br /><small>(sous réserve de conformité de votre dossier)</small></p>
        <p v-if="lot == 'lot2'">Vous avez gagné une enceinte Bluetooth  <br /><small>(sous réserve de conformité de votre dossier)</small></p>
        <p v-if="lot == 'lot3'">Vous avez gagné un robot de cuisine  <br /><small>(sous réserve de conformité de votre dossier)</small></p>
        <p v-if="lot == 'lot4'">Vous avez gagné une trottinette électrique  <br /><small>(sous réserve de conformité de votre dossier)</small></p>
        <p v-if="lot == 'lot5'">Vous avez gagné 20€ en bons de réduction  <br /><small>(sous réserve de conformité de votre dossier)</small></p>        
        <p v-if="lot == 'lot6'">Vous avez gagné un livret Montorsi <br />de 12 recettes gourmandes et savoureuses (à télécharger) <br /><small>(sous réserve de conformité de votre dossier)</small></p>                                    
        <div v-if="lot != 'lot6'">
          Merci pour votre participation !  <br />
          Votre demande a bien été enregistrée.<br /> Vous allez recevoir un e-mail de confirmation.
        </div>
        <div v-if="lot == 'lot6'">
          Merci pour votre participation !  <br />
          Votre demande a bien été enregistrée.<br /> Vous allez recevoir un e-mail de confirmation et pourrez télécharger votre livret.
        </div>        
    </div>   
  </main>
</template>
<script>
export default {
  name: 'win',
  data: function() {
    return {
       lot : window.lot

    };
  },
  mounted() {
    if(!window.lot) {
     this.$router.replace("/");
     return false
    }
  }  
}
</script>
